import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DigitalResourceViewer } from "@/components/catalog/DigitalResourceViewer";
import { guestOpacApi } from "@/lib/api/guest-opac";

interface GuestDigitalResourcePanelProps {
  publicId: string;
  tenantSlug: string;
  title: string;
  digitalType?: string | null;
}

export function GuestDigitalResourcePanel({
  publicId,
  tenantSlug,
  title,
  digitalType,
}: GuestDigitalResourcePanelProps) {
  const [fileUrl, setFileUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const openReader = async () => {
    setLoading(true);
    setError(null);
    try {
      const access = await guestOpacApi.getDigitalAccess(publicId, tenantSlug);
      setFileUrl(access.fileUrl);
    } catch {
      setError("Unable to open this digital resource.");
    } finally {
      setLoading(false);
    }
  };

  if (fileUrl) {
    return (
      <div className="space-y-3">
        <DigitalResourceViewer
          fileUrl={fileUrl}
          type={digitalType ?? "PDF"}
          title={title}
          onError={(msg) => setError(msg)}
        />
        {error && (
          <p className="text-sm text-red-600" role="alert">
            {error}
          </p>
        )}
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <Button onClick={openReader} disabled={loading}>
        {loading ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Opening reader...
          </>
        ) : (
          "View digital resource"
        )}
      </Button>
      {error && (
        <p className="text-sm text-red-600" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
